<div id="company-select-page" class="login-page container">
  <div class="login-box">
    <div class="logo-container">
      <img id="black-logo" src="/assets/ProductioneerLogoBlack_Transparent.png" />
      <h4 class="product-title"><em>Portal</em></h4>
    </div>
    <div class="login-form my-4" *ngIf="isLoading">
      <app-loading-indicator [medium]="true" [message]="'Preparing company data'"></app-loading-indicator>
    </div>
    <form class="login-form" *ngIf="!isLoading" [formGroup]="companySelectForm" (ngSubmit)="onSelect()" autocomplete="on">
      <div class={{infoClass}} *ngIf="infoMessage" role="alert">
        {{infoMessage}}
      </div>
      <div class="error-container" *ngIf="error.isPresent">
        <p class="text-danger"><strong>{{error.message}}</strong></p>
      </div>
      <div class="form-group">
        <label for="companySelect"><strong>Select Company</strong></label>
        <select class="form-control rr-form-control" formControlName="companySelect">
          <option value="" disabled>Select a company</option>
          <option *ngFor="let company of companyOptions; index as i" [value]="i">{{company.companyName}}</option>
        </select>
      </div>

      <div class="login-btn-container">
        <button type="submit" class="btn btn-primary btn-lg mi4-big-btn" [disabled]="isSubmitting || !companySelectForm.valid">
          <span *ngIf="!isSubmitting">Submit</span>
          <span *ngIf="isSubmitting"><span class="spinner-border" role="status"></span> Submitting</span>
        </button>
      </div>
      <div class="alternate-link-container" *ngIf="error.isPresent">
        <a routerLink="/logout" class="btn btn-outline-secondary mi4-big-link">Back to Login</a>
      </div>
    </form>
  </div>
</div>
<app-footer></app-footer>
